import React from 'react';
import PropTypes from 'prop-types';

import LogoPrimary from "../assets/detect-v2-left-aligned.svg";
import LogoSecondary from "../assets/ss-logo-secondary.png";
import LogoSecondaryLight from "../assets/detect-logo-dark-color.png";

import {
	makeStyles
} from '@material-ui/core';

//const secondaryLightSize = {width: 151, height: 26};
const topLogoSize = {width: 201, height: 35};
//const primarySize = {w}
const styles = makeStyles(theme => ({
	root: {
		maxHeight: theme.spacing(8)
	},

	secondaryLight: {
		width: topLogoSize.width,
		height: topLogoSize.height,
		backgroundSize: `${topLogoSize.width + 15}px`,
		background: 'url("'+LogoSecondaryLight+'") no-repeat center',
	},

	primary: {
		width: topLogoSize.width,
		height: topLogoSize.height,
		backgroundSize: topLogoSize.width,
		background: 'url("'+LogoPrimary+'") no-repeat center'
	},
}));

function Branding(props) {
	const classes = styles();
	let {className, secondary, light} = props;

	return (
		<div className={`${classes.root} ${className}`}>
			{
				secondary ? 
					light ?
						<div className={classes.secondaryLight} />
						:
						<img src={LogoSecondary} width="240" height="65" alt="" />
					:
					<div className={classes.primary} alt="" />
			}
		</div>
	);
}

Branding.defaultProps = {
	light: false,
	secondary: false
};

Branding.propTypes = {
	className: PropTypes.string,
	light: PropTypes.bool, // currently only pertains to secondary
	secondary: PropTypes.bool,
};

export default Branding;
